import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import "@fontsource-variable/inter";
import "./index.css";
import { clearOfflineData, registerServiceWorker } from "./components/pwa";
import { setRouter } from "./lib/nav";
import { queryClient } from "./lib/query";
import { loadConfig } from "./lib/config";
import { initSupabase } from "./lib/supabase";
import { makeRouter } from "./router";

async function start() {
  const cfg = await loadConfig();
  const sb = initSupabase(cfg);
  const router = makeRouter(queryClient);
  setRouter(router);
  sb.auth.onAuthStateChange((event) => {
    if (event === "SIGNED_IN" || event === "SIGNED_OUT") clearOfflineData();
    if (event === "SIGNED_OUT") {
      queryClient.clear();
      router.navigate({ to: "/login" });
    }
  });
  registerServiceWorker();
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

start();
